import appDeductionplans from "../../views/appPlans/deductions.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "deductionplans";
  const params = ["page", "limit"];

  $stateProvider.state("deductionplans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appDeductionplans,
      },
    },
    reloadOnSearch: false,
    data: { title: "Deductionplans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/deductionplans/deductionplans.urls.js